export default "__VITE_ASSET__183d0806__"